import { SxProps, Theme } from '@mui/material';

export const styledTypographySx: SxProps<Theme> = (theme) => ({
	whiteSpace: 'break-spaces',
	alignItems: 'baseline',
	lineHeight: 1.2,

	// Nested selectors
	'li, a': { textDecoration: 'none' },
	a: {
		color: theme.palette.secondary.main,
		'&:hover': {
			textDecoration: 'underline',
			cursor: 'pointer',
		},
	},
	'&.accounts-links-title': {
		margin: `${theme.spacing(3)} 0 ${theme.spacing(2)}`,
	},
	'&.MuiTypography-gutterBottom': {
		marginBottom: theme.spacing(1),
	},
	'&.total-discount': { color: theme.palette.text.highlight },
	'&.product-shordesc': {
		fontSize: 12,
		color: theme.palette.text.secondary,
	},
	'&.product-quantity': {
		fontSize: 17,
		color: theme.palette.text.primary,
	},
	'.strikethrough': {
		textDecoration: 'line-through',
		fontSize: '0.9em',
		opacity: 0.8,
		marginRight: theme.spacing(1),
	},
	'&.normal-white-space': { whiteSpace: 'normal' },
	'.line-through > *': { textDecoration: 'line-through' },
	'&.expanded-menu-bold': {
		fontSize: '1.15em',
		fontWeight: 'bold',
		marginBottom: theme.spacing(1),
	},
	'&.expanded-menu-sub-links': {
		marginBottom: theme.spacing(0.75),
		marginTop: theme.spacing(0.75),
	},
	'&.expanded-menu-text': {
		color: theme.palette.text.expandedMenu,
		fontSize: '1.15em',
		'&.MuiTypography-body2': { fontSize: 12 },
	},
	'&.wrapText': {
		overflowWrap: 'break-word',
		wordWrap: 'break-word',
		wordBreak: 'break-word',
	},
	'&.error': { color: theme.palette.text.alert },
	'&.shipment-group-heading': { fontWeight: 'bold' },
	'&.masColor': {
		fontSize: '2em',
		color: theme.palette.text.secondary,
	},
	'&.link': {
		color: theme.palette.secondary.main,
		cursor: 'pointer',
	},
	'&.labelDesign': {
		display: 'flex',
		alignItems: 'center',
		'&.MuiInputAdornment-positionEnd': {
			marginLeft: '5px',
			height: 'auto',
		},
	},
	'&.text-ellipsis': { textOverflow: 'ellipsis' },
	'&.gray300': { color: theme.palette.grey[300] },
});
